export const headerItemSx = {
  wordBreak: 'initial',
  whiteSpace: 'nowrap',
};
